import * as React from 'react';
export default function WarningTriangleFilled() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.545 5.52c1.014-2.023 3.903-2.023 4.917.001l5.258 10.497c.916 1.829-.414 3.982-2.459 3.982H6.74c-2.046 0-3.375-2.154-2.458-3.983L9.545 5.52ZM11 10a1 1 0 0 1 2 0v2a1 1 0 1 1-2 0v-2Zm1 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
    fill: "currentColor"
  }));
}